/// <reference path="../../lib/app.d.ts" />

import {FieldBase} from "../lib/form";
import form from "../lib/form";

import {TemplateEngine} from "../lib/template-engine";
import {Translator} from "../utils/translator";
import {AppParamsURL} from "../application/interfaces";
import {Application} from "../application/application";
import logging from "../utils/log";
import {slugify} from "../lib/slugify";
type RegisterResult = "success" | "technical";
type JoinResult = "success" | "technical";

export class AuthPanel
{
	reason: string;
	private TAG = "[AuthPanel]";
	private initialized = false;
	private pic: string;
	private onClosed: Function;
	private gameOver: boolean;

	constructor(private $root : JQuery,
	            private app : Application,
	            private templateEngine : TemplateEngine,
	            private translator : Translator,

	            private captchaURL : string,

	            private url : AppParamsURL,

	            private onRegister : (user : string,
	                                  email : string,
	                                  passwd : string,
	                                  onResponse : (response : string) => void ) => void,

	            private onLogin : (user : string,
	                               passwd : string,
	                               captcha : string,
	                               remember : boolean,
	                               onResponse : (response : string) => void ) => void,

	            private onReminder : (email : string,
	                                  onResponse : (response : string) => void ) => void
	) {

		$(document).on("click", ".sxcca-close", () => {
			this.hide();

			//$.each($('video'), function(index, videoObj) { if(typeof $(videoObj).attr('id') !== "undefined") { let videoDOM : HTMLVideoElement = <HTMLVideoElement>document.getElementById($(videoObj).attr('id')); videoDOM.pause(); videoDOM.src = ""; } } );
		});

		$(document).on("click", ".sxcca-toggle-login", () => {
			this.show("login", this.pic, this.reason, false, this.onClosed)
		});

		$(document).on("click", ".sxcca-toggle-register", () => {
			this.show("register", this.pic, this.reason, false, this.onClosed)
		});

		$root.on("click", "span.terms", () => {
			if(typeof this.app.options.chatIncludeType !== 'undefined' && this.app.options.chatIncludeType.indexOf("babesIFrame") !== -1  && $('.footer-links a[href=\'/terms\']').length>0) {
				$('.footer-links a[href=\'/terms\']').click()
			}else{
				if (typeof this.url.terms === "string") {
					let url = this.url.terms;
					window.open(url, '_blank');
				} else {
					this.url.terms();
				}
			}
		});

		$root.on("click", "span.privacy", () => {
			if(typeof this.app.options.chatIncludeType !== 'undefined' && this.app.options.chatIncludeType.indexOf("babesIFrame") !== -1  && $('.footer-links a[href=\'/privacy\']').length>0) {
				$('.footer-links a[href=\'/privacy\']').click()
			}else{
				if (typeof this.url.privacy === "string") {
					let url = this.url.privacy;
					window.open(url, '_blank');
				} else {
					this.url.privacy();
				}
			}
		});

		$(document).on("click", ".sxcca-reminder-toggle", () => {
			this.toggleReminder(this.reminderState === "off" ? "form" : "off");
		});

		$(document).on("submit", "form.sxcca-form-register", (e) => {
			e.preventDefault();
			this.onRegisterSubmitted();
		});

		$(document).on("submit", "form.sxcca-form-register-ok", (e) => {
			e.preventDefault();
			this.hide();
		});

		$(document).on("submit", "form.sxcca-form-reminder-ok", (e) => {
			e.preventDefault();
			this.toggleReminder("off");
		});

		$(document).on("submit", "form.sxcca-form-login", (e) => {
			e.preventDefault();
			logging.log("login submit");
			this.onLoginSubmitted();
		});

		$(document).on("submit", "form.sxcca-form-reminder", (e) => {
			e.preventDefault();
			this.onReminderSubmitted();
		});
	}

	setGameOver(): any
	{
		this.gameOver = true;
		this.$root.addClass(".sxcca-game-over");
	}

	show(panel : string, profilePic : string, reason : string = null, inheritStream : boolean = false, onClosed : Function = null)
	{
		logging.log(this.TAG, "show", panel, profilePic);

		/*if(typeof this.app.options.chatIncludeType != 'undefined' && this.app.options.chatIncludeType == 'babesIFrame') {
			if(panel == 'login') { window.parent.postMessage('onLogin', '*'); return; }
			else if(panel == 'register') { window.parent.postMessage('onRegister', '*'); return; }
			else if(panel == 'reminder') { window.parent.postMessage('onReminder', '*'); return; }
		}*/

		this.pic = profilePic;
		this.reason = reason;
		this.onClosed = onClosed;

		let $panel = this.templateEngine.render("auth-panel", {
			mode: panel,
			loginPanel: panel === "login",
			registerPanel: panel === "register",
			reminderPanel: panel === "reminder",
			gameOver: this.gameOver,
		});

		this.$root
			.empty()
			.append($panel)
			.addClass("sxc-visible");

		this.$root.find("img").attr("src", profilePic);

		if (this.gameOver && reason!=="free") {
			reason = "game_over";
		}

		if (reason==="free") {
			this.$root.find(".sxcca-title").text(this.translator.t("auth_panel_title_register_" + reason));
		}

		if (reason) {
			this.$root.find(".sxcca-motto span").text(this.translator.t("auth_panel_motto_register_" + reason));
		} else {
			this.$root.find(".sxcca-motto span").text(this.translator.t("auth_panel_motto_register_" + (Math.floor(Math.random() * 3 ) + 1 )));
		}

		form.initialize(this.$root);
	}

	private reminderState : "off" | "form" | "result" = "off";

	toggleReminder(state : "off" | "form" | "result")
	{
		this.reminderState = state;

		if (state === "form") {
			this.$root.find(".sxcca-form-reminder").addClass("sxc-visible");
			this.$root.find(".sxcca-form-reminder-ok").removeClass("sxc-visible");
			this.$root.find(".sxcca-reminder-toggle").addClass("sxc-visible");
		} else if (state === "result") {
			this.$root.find(".sxcca-form-reminder").removeClass("sxc-visible");
			this.$root.find(".sxcca-form-reminder-ok").addClass("sxc-visible");
			this.$root.find(".sxcca-reminder-toggle").addClass("sxc-visible");
		} else {
			this.$root.find(".sxcca-form-reminder").removeClass("sxc-visible");
			this.$root.find(".sxcca-form-reminder-ok").removeClass("sxc-visible");
			this.$root.find(".sxcca-reminder-toggle").removeClass("sxc-visible");
		}
	}

	hide()
	{
		if(typeof this.app.options.chatIncludeType !== 'undefined') {//For new design
			this.onClosed = null;
			$(window).scroll();
			$(".sxc-chat").scroll();
		}

		this.$root.removeClass("sxc-visible");

		if (this.onClosed) {
			this.onClosed();
			this.onClosed = null;
		}

		if(typeof this.app.options.chatIncludeType === 'undefined') {
			$.each($('video'), function (index, videoObj) {if (typeof $(videoObj).attr('id') !== "undefined") {let videoDOM: HTMLVideoElement = <HTMLVideoElement>document.getElementById($(videoObj).attr('id'));videoDOM.pause();videoDOM.src = "";}});
		}
	}

	isVisible()
	{
		return this.$root.hasClass("sxc-visible");
	}

	esc()
	{
		if (this.isVisible() /*&& !this.gameOver*/) {
			this.hide();
		}
	}

	onRegisterSubmitted()
	{
		const $form = this.$root.find(".sxcca-form-register");
		const formHandler : FieldBase = $form.data("sxcf");

		let errors = formHandler.validate();

		if (errors.length) {
			errors[0].field.focus();
			return;
		}

		let name = $form.find("[name=name]").val();
		let email = $form.find("[name=email]").val();
		let passwd = $form.find("[name=passwd]").val();
		let passwd2 = $form.find("[name=passwd2]").val();
		let accept = $form.find("[name=passwd2]").val();

		let error = (error) =>
		{
			switch (error) {
				case "passwd_mismatch":
					$form.find("[name=passwd2]").focus().data("sxcf").triggerError("invalid");
					break;

				case "accept_req":
					$form.find("[name=accept]").focus().data("sxcf").triggerError("accept_req");
					break;

				case "join_err_usernametaken":
					$form.find("[name=name]").focus().data("sxcf").triggerError("taken");
					break;

				case "join_err_usernameinvalid":
					$form.find("[name=name]").focus().data("sxcf").triggerError("invalid");
					break;
				case "join_err_emailinvalid":
					$form.find("[name=email]").focus().data("sxcf").triggerError("invalid");
					break;

				case "join_err_emailused":
					$form.find("[name=email]").focus().data("sxcf").triggerError("taken");
					break;

				case "join_err_passwdinvalid":
					$form.find("[name=passwd]").focus().data("sxcf").triggerError("invalid");
					break;

				case "join_err_iptempban":
					$form.find("[name=name]").data("sxcf").triggerError("banned");
					break;

				case "join_err_disabled":
					$form.find("[name=name]").data("sxcf").triggerError("banned");
					break;

				default:
					formHandler.triggerError("technical");
			}
		};

		if (!$form.find("[name=accept]").is(":checked")) {
			error("accept_req");
			return;
		}

		if (passwd !== passwd2) {
			error("passwd_mismatch");
			return;
		}

		$form.find(".sxcf-button").last().prop("disabled","true");
		$form.append('<div id="wait_chat_native"><div class="lds-ellipsis-white"></div></div>');
		$form.find("#wait_chat_white,#wait_chat_white *").show();
		this.onRegister(name, email, passwd, (res) =>
		{
			$form.find(".sxcf-button").last().removeAttr("disabled");
			$form.find("#wait_chat_native").remove();
			if (res === "success") {
				this.onRegisterSuccessful();
			} else {
				error(res);
			}
		});
	}

	showCaptcha()
	{
		this.$root.find(".sxcca-captcha input")
			.attr("required", "required");

		this.$root.find(".sxcca-captcha")
			.show()
			.find("img").attr("src", this.captchaURL + "rnd=" + Math.random())
		;
	}

	onLoginSubmitted()
	{
		const $form = this.$root.find(".sxcca-form-login");
		const formHandler : FieldBase = $form.data("sxcf");

		let name = $form.find("[name=name]").val();
		let passwd = $form.find("[name=passwd]").val();
		let captcha = $form.find("[name=captcha]").val();
		let remember = $form.find("[name=remember]").is(":checked");

		let error = (error) =>
		{
			this.showCaptcha();

			switch (error) {
				case "login_err_invalidcaptcha":
					$form.find("[name=captcha]").focus().data("sxcf").triggerError("invalid");
					break;

				case "login_err_emailauthrequired":
					$form.find("[name=name]").focus().data("sxcf").triggerError("not-verified");
					break;

				case "login_err_invalidpass":
					$form.find("[name=name]").focus().data("sxcf").triggerError("invalid");
					break;

				case "login_err_iptempban":
					$form.find("[name=name]").focus().data("sxcf").triggerError("banned");
					break;

				case "login_err_disabled":
					$form.find("[name=name]").focus().data("sxcf").triggerError("banned");
					break;

				default:
					formHandler.triggerError("technical");
			}
		};

		let errors = formHandler.validate();

		if (errors.length) {
			errors[0].field.focus();
			return;
		}


		this.onLogin(name, passwd, captcha, remember, (res) =>
		{
			logging.log("onlogin", res);
			if (res === "success") {
				location.reload();
			} else {
				error(res);
			}
		});
	}

	onReminderSubmitted()
	{
		const $form = this.$root.find(".sxcca-form-reminder");
		const formHandler : FieldBase = $form.data("sxcf");

		let email = $form.find("[name=email]").val();

		let errors = formHandler.validate();

		if (errors.length) {
			errors[0].field.focus();
			return;
		}

		this.onReminder(email, (res) =>
		{
			if (res === "success") {
				this.toggleReminder("result")
			} else {
				formHandler.triggerError("technical");
			}
		});
	}

	onRegisterSuccessful()
	{
		this.$root.find(".sxcca-form-register").hide();
		this.$root.find(".sxcca-form-register-ok").show();
	}

	shakeButton()
	{

		this.$root.find("button").css("animation", "sxcc-shake-button 1s linear");

		setTimeout(() => {
			this.$root.find("button").css("animation", "");
		}, 1000);
	}
}

